import { Person as MemberIcon, PersonAdd as RequestIcon } from "@mui/icons-material";

interface MembershipStatusProps {
  userIsOwner: boolean;
  userIsFacilitator?: boolean;
  userIsMember: boolean;
  userIsPending: boolean;
}

interface MembershipStatus {
  Icon: typeof MemberIcon | typeof RequestIcon;
  color: "primary" | "secondary" | "success" | "warning";
  label: string;
}

export const useMembershipStatus = ({
  userIsOwner,
  userIsFacilitator = false,
  userIsMember,
  userIsPending,
}: MembershipStatusProps): MembershipStatus | null => {
  if (userIsOwner) {
    return { Icon: MemberIcon, color: "primary", label: "Leader" };
  }
  if (userIsFacilitator) {
    return { Icon: MemberIcon, color: "secondary", label: "Facilitator" };
  }
  if (userIsMember) {
    return { Icon: MemberIcon, color: "success", label: "Member" };
  }
  if (userIsPending) {
    return { Icon: RequestIcon, color: "warning", label: "Pending" };
  }
  return null; // Not a member - no chip needed
};
